import React from "react";
import logo from "../../assets/images/web_logo.png";

const NewHeader = () => {
  return (
    <header className="bg-gradient-to-r from-blue-100 to-blue-300 font-[Poppins] text-[#3d0000] px-4 sm:px-6 py-2 shadow-md">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2 sm:gap-4 transition-all duration-700 ease-in-out opacity-0 animate-[fadeIn_0.8s_ease-in-out_forwards]">
   
        <div className="flex items-center gap-3 sm:gap-4">
      
          <div className="w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white border border-blue-400 shadow-lg overflow-hidden flex items-center justify-center transition duration-500 hover:scale-105">
            <img
              src={logo}
              alt="Logo"
              className="w-full h-full object-cover rounded-full"
            />
          </div>

         
          <div className="transition-opacity duration-700 ease-in-out delay-100 opacity-0 animate-[fadeIn_1s_ease-in-out_forwards] leading-tight">
           <span className="font-semibold text-2xl ml-3 hidden md:block">
          Sansar Sadasya
        </span>
            <span className="font-semibold text-lg ml-3 hidden md:block">
              E-Commerce Pvt. Ltd
            </span>
          </div>
        </div>

        <div className="opacity-0 animate-[fadeIn_1.2s_ease-in-out_forwards] delay-200">
          <a href="mailto:support@sansarsadasya.com">
            <button className="bg-[#3d0000] hover:bg-[#5a1a1a] text-white py-1.5 px-4 sm:px-5 rounded-lg text-xs sm:text-sm transition-all duration-300">
              Contact With Us
            </button>
          </a>
        </div>
      </div>
    </header>
  );
};

export default NewHeader;
